/* altE Kits & Bundles: filters for the browse page and add-all-to-cart for component-sum bundles. Without this script every bundle stays listed and ordering falls back to the written quote link. */
(() => {
  const forms = Array.from(document.querySelectorAll('[data-b-addall]'));
  const label = (b, text) => { const s = b.querySelector('span'); if (s) s.textContent = text; };
  forms.forEach((f) => {
    let items;
    try { items = JSON.parse(f.getAttribute('data-b-items')); } catch (e) { return; }
    if (!Array.isArray(items) || !items.length) return;
    const btn = f.querySelector('button');
    const err = f.querySelector('[data-b-addall-err]');
    const name = f.getAttribute('data-b-name');
    const bundle = f.getAttribute('data-b-id');
    f.hidden = false;
    f.addEventListener('submit', (e) => {
      e.preventDefault();
      if (btn.disabled) return;
      err.hidden = true;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      label(btn, 'Adding…');
      const body = { items: items.map((i) => ({ id: i.id, quantity: i.quantity, properties: { Bundle: name, _bundle_id: bundle } })) };
      fetch(f.getAttribute('data-b-add-url'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then((r) => r.json().catch(() => ({})).then((j) => ({ ok: r.ok, j })))
        .then((res) => {
          if (res.ok) { window.location.assign(f.getAttribute('data-b-cart-url')); return; }
          throw new Error((res.j && (res.j.description || res.j.message)) || '');
        })
        .catch((x) => {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          label(btn, 'Add bundle to cart');
          err.textContent = 'We could not add every part of this bundle. ' + (x && x.message ? x.message + ' ' : '') + 'Check your cart, or request a written quote instead.';
          err.hidden = false;
        });
    });
  });
})();

(() => {
  const root = document.querySelector('[data-b-root]');
  const form = root && root.querySelector('[data-b-filters]');
  if (!form) return;
  const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
  const items = $$('[data-b-item]');
  const sections = $$('[data-b-section]');
  const count = root.querySelector('[data-b-count]');
  const none = root.querySelector('[data-b-none]');
  const resets = [form.querySelector('[data-b-reset]'), root.querySelector('[data-b-reset-none]')].filter(Boolean);
  const total = items.length;
  const box = root.querySelector('[data-b-filterbox]');
  const badge = root.querySelector('[data-b-filtern]');

  const active = () => {
    const sel = {};
    $$('input:checked', form).forEach((i) => { (sel[i.name] = sel[i.name] || []).push(i.value); });
    return sel;
  };

  const apply = () => {
    const sel = active();
    const keys = Object.keys(sel);
    let shown = 0;
    items.forEach((li) => {
      const ok = keys.every((k) => sel[k].includes(li.getAttribute('data-b-' + k)));
      li.hidden = !ok;
      if (ok) shown += 1;
    });
    sections.forEach((s) => { s.hidden = !$$('[data-b-item]:not([hidden])', s).length; });
    none.hidden = shown !== 0;
    const filtered = keys.length > 0;
    resets.forEach((b) => { if (b !== resets[1]) b.hidden = !filtered; });
    if (badge) {
      const n = $$('input:checked', form).length;
      badge.hidden = n === 0;
      badge.textContent = n + ' selected';
    }
    count.hidden = !filtered;
    count.textContent = filtered ? 'Showing ' + shown + ' of ' + total + ' bundles' : '';
  };

  const reset = () => {
    $$('input:checked', form).forEach((i) => { i.checked = false; });
    apply();
    const first = form.querySelector('input');
    if (box && !box.open) box.open = true;
    if (first) first.focus();
  };

  form.hidden = false;
  if (box) box.hidden = false;
  form.addEventListener('change', apply);
  form.addEventListener('submit', (e) => e.preventDefault());
  resets.forEach((b) => b.addEventListener('click', reset));
  apply();
})();
